import classnames from 'classnames';

import styles from './index.module.scss';

type LoaderProps = {
  className?: string;
  invert?: boolean;
  isRelative?: boolean;
  size?: number;
  strokeSize?: number;
};

export const Loader = ({ className, invert = false, isRelative = false, size = 32, strokeSize = 4 }: LoaderProps) => {
  const circleSize = size / 2 - 2;
  return (
    <div className={classnames(styles.loader, isRelative && styles.isRelative, invert && styles.invert, className)}>
      <svg height={`${size}`} stroke="#fff" viewBox={`-1 -1 ${size} ${size}`} width={`${size}`} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <g strokeWidth={`${strokeSize}`} transform="translate(1 1)">
            <circle cx={`${circleSize}`} cy={`${circleSize}`} r={`${circleSize}`} strokeOpacity=".5" />
            <path d={`M${circleSize * 2} ${circleSize}c0-9.94-8.06-${circleSize}-${circleSize}-${circleSize}`}>
              <animateTransform
                attributeName="transform"
                dur="1s"
                from={`0 ${circleSize} ${circleSize}`}
                repeatCount="indefinite"
                to={`360 ${circleSize} ${circleSize}`}
                type="rotate"
              />
            </path>
          </g>
        </g>
      </svg>
    </div>
  );
};
